import React from 'react'
import styled from 'styled-components'
import { timelineObjects } from '../ObjectFunctions/timelineObjects'
import {OverlayTrigger, Tooltip } from 'react-bootstrap'
import { calculateDurationSince } from '../ObjectFunctions/calculateDuration'
import {motion} from 'framer-motion'

const Container = styled.div({
    marginTop: 100
})

const TimeLine = () => {
  return (
    <Container className='me-5 ps-4 text-white w-100'>
            {timelineObjects.map((obj, index) => (
              <React.Fragment key={index}>
                <motion.div 
                
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 1, delay: 0.5}}

                className="position-relative border-4 p-5 w-100 border-start border-primary">
                  <motion.h5 
                  initial={{opacity: 0, y: 40}}
                  whileInView={{opacity: 1, y: 0}}
                  transition={{duration: 1, delay: 0.6}}
                  className=' position-absolute conclusiontime'>{obj.conclusion} <span className='text-black'>--</span> <span className='text-blue subfont'>({calculateDurationSince(obj.start, obj.conclusion)})</span></motion.h5>
                  <motion.h5 
                  initial={{opacity: 0, y: 40}}
                  whileInView={{opacity: 1, y: 0}}
                  transition={{duration: 1, delay: 0.6}}
                  className='position-absolute  starttime'>{obj.start}</motion.h5>
                  <div className="position-absolute sphere bg-primary rounded-circle "></div>
                  <div className="mt-4 d-flex w-100 align-items-center  justify-content-between">
                    <h4>{obj.position}</h4>
                  </div>
                  <h2><span className='text-primary'>@</span> {obj.company}</h2>
                  
                  <div className="mt-4 mb-5 pt-3">
                    <h5 className='mb-3'>Tech stack</h5>
                    <div className=" overflow-auto  w-md-50 d-flex align-items-center ">
                      {obj.stack.map((tool, index) => (
                        <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id={"tooltip-top"}>{tool.label}</Tooltip>}
                      >
                          <div className="w-auto me-5" key={index}>{tool.icon}</div>
                      </OverlayTrigger>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4 mb-4"> 
                  <h5 className='mb-4'>Industry</h5>
                    <div className=" overflow-auto hidescroll d-flex">
                      {obj.fields.map(field => (
                        <p className=' text-nowrap  w-auto me-2 fw-bold rounded bg-white text-primary ps-2 pe-2'>{field}</p>
                      ))}
                    </div>
                  </div>
              </motion.div>
              {index + 1 < timelineObjects.length && 
                <div className='spacer'></div>
              }
            </React.Fragment>
            ))}
            
    </Container>
  )
}

export default TimeLine